
<br />
<div *ngIf="data" class="add-btn-postion">
    <div>
        <ng-container *ngFor="let hdrbtn of hdrbtns">
            <button *ngIf="!hdrbtn.ishide" type="button" class="btn btn-primary" (click)="click(hdrbtn,null)">{{hdrbtn.title}}</button>
        </ng-container>
    </div>
</div>
<br />



<div ngif ="pdata">
   
                <div *ngFor="let column of columns">

                 <div class="col-md-6">
                      <b>  {{column.display}}</b>
                   </div>
                     
                      <div class="col-md-6">

               {{pdata[column.variable] | format:column.filter}}
                        </div>
                  
        

  </div>
  </div>

